import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getSeventhAnalyses,
  getSeventhAnalysis,
  clearLocalSeventhAnalyses,
  clearLocalActiveSeventhAnalysis
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  seventhAnalysis: { 
    id: '', 
    input: '', 
    result: '', 
    voice: null, 
    status: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    seventhAnalysis: false 
  }
};

const slice = createSlice({
  name: 'seventhAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSeventhAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSeventhAnalyses.fulfilled, (state, action) => {
        const { seventh_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...seventh_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getSeventhAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSeventhAnalysis.pending, (state) => {
        state.loading.seventhAnalysis = true;
      })
      .addCase(getSeventhAnalysis.fulfilled, (state, action) => {
        const { data: { seventh_analysis }, cable } = action.payload;
        const foundedSeventhAnalysis = !!_find(state.all.data, (s) => s.id === seventh_analysis.id);
        const updatedSeventhAnalysis = { ...state.seventhAnalysis, ...seventh_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSeventhAnalysis ? _map(state.all.data, (e) => e.id === seventh_analysis.id ? { ...e, ...seventh_analysis } : e) : [...[seventh_analysis], ...oldAllData]; 
        const pagination = foundedSeventhAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.seventhAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSeventhAnalysis && !cable) state.seventhAnalysis = updatedSeventhAnalysis;       
      })
      .addCase(getSeventhAnalysis.rejected, (state) => {
        state.loading.seventhAnalysis = false;
      })
      .addCase(clearLocalSeventhAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSeventhAnalysis, state => {
        state.seventhAnalysis = initialState.seventhAnalysis;
      })
  }
})

export default slice.reducer;